/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GainMode {
}

export enum GainMode_Enum {
  kHighGain = 0,
  kLowGain = 1,
  UNRECOGNIZED = -1,
}

export function gainMode_EnumFromJSON(object: any): GainMode_Enum {
  switch (object) {
    case 0:
    case "kHighGain":
      return GainMode_Enum.kHighGain;
    case 1:
    case "kLowGain":
      return GainMode_Enum.kLowGain;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GainMode_Enum.UNRECOGNIZED;
  }
}

export function gainMode_EnumToJSON(object: GainMode_Enum): string {
  switch (object) {
    case GainMode_Enum.kHighGain:
      return "kHighGain";
    case GainMode_Enum.kLowGain:
      return "kLowGain";
    case GainMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseGainMode(): GainMode {
  return {};
}

export const GainMode = {
  encode(_: GainMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GainMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGainMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GainMode {
    return {};
  },

  toJSON(_: GainMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GainMode>, I>>(base?: I): GainMode {
    return GainMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GainMode>, I>>(_: I): GainMode {
    const message = createBaseGainMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
